var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-container"},[_c('user-update',{attrs:{"type":3,"uid":_vm.$route.params.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }